import CryptoJS from 'crypto-js';

// Static encryption key - placeholder for now
const ENCRYPTION_KEY = 'u50Oy3UCVAIngRBb0NbZZA==';

// Base API URL
//https://finlead-ai-49666543281.asia-south1.run.app
//http://localhost:5001
const BASE_API_URL = 'https://finlead-ai-49666543281.asia-south1.run.app';

/**
 * Generate tenant token
 * @param {string} tenantId 
 * @param {string} tenantName 
 * @returns {Promise<{tenantId: string, token: string}>}
 */
export const generateTenantToken = async (tenantId, tenantName) => {
  try {
    const response = await fetch(`${BASE_API_URL}/api/v1.0/tenants/generate`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        tenantId,
        tenantName
      })
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error generating tenant token:', error);
    throw error;
  }
};

/**
 * Encrypt data using AES encryption
 * @param {any} data - Data to encrypt
 * @returns {string} - Encrypted string
 */
export const encryptData = (data) => {
  try {
    const jsonString = JSON.stringify(data);
    // Convert the key to Utf8 format
    const utf8Key = CryptoJS.enc.Utf8.parse(ENCRYPTION_KEY);

    // Encrypt the data
    const encrypted = CryptoJS.AES.encrypt(jsonString, utf8Key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
    // const hashedKey = CryptoJS.SHA256(ENCRYPTION_KEY).toString(); // Hash the key
    // const encrypted = CryptoJS.AES.encrypt(jsonString, ENCRYPTION_KEY).toString();
    return encrypted.toString();
  } catch (error) {
    console.error('Error encrypting data:', error);
    throw error;
  }
};

/**
 * Decrypt data using AES decryption
 * @param {string} encryptedData - Encrypted string
 * @returns {any} - Decrypted data
 */
export const decryptData = (encryptedData) => {
  try {
    // Convert the key to Utf8 format
    const utf8Key = CryptoJS.enc.Utf8.parse(ENCRYPTION_KEY);

    // Decrypt the data
    const decrypted = CryptoJS.AES.decrypt(encryptedData, utf8Key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
    });

    // const decrypted = CryptoJS.AES.decrypt(encryptedData, ENCRYPTION_KEY);
    const jsonString = decrypted.toString(CryptoJS.enc.Utf8);
    return JSON.parse(jsonString);
  } catch (error) {
    console.error('Error decrypting data:', error);
    throw error;
  }
};

/**
 * Make encrypted API call with tenant token
 * @param {string} url - API endpoint
 * @param {any} data - Data to send
 * @param {string} token - Tenant token
 * @returns {Promise<any>} - Decrypted response
 */
export const makeEncryptedApiCall = async (uri, data, token) => {
  try {
    // Encrypt the request data
    const encryptedData = encryptData(data);
    
    const response = await fetch(`${BASE_API_URL}${uri}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'authorization': `Bearer ${token}`
      },
      body: JSON.stringify({
        encryptedData
      })
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const responseData = await response.json();
    
    // Decrypt the response
    const decryptedData = decryptData(responseData.encryptedData || responseData.output);
    return decryptedData;
  } catch (error) {
    console.error('Error making encrypted API call:', error);
    throw error;
  }
};
